import { useSuspenseQuery } from '@tanstack/react-query';
import { regionAtcGet } from '@/api/core/region/regionAtcGet';

export const useRegionAtc = () => useSuspenseQuery({
    queryKey: ['regionAtc'],
    queryFn: () => regionAtcGet().then(r => r.payload).catch(() => [])
});
